import { Component } from '@angular/core';

@Component({
  selector: 'app-details-company',
  standalone: false,
  templateUrl: './details-company.component.html',
  styleUrl: './details-company.component.scss'
})
export class DetailsCompanyComponent {

}
